import {ReactElement, useMemo, Fragment} from 'react';
import {useMemberProduct} from '../contexts/MemberProductProvider.client';
import {AverageRatingType} from '../types/backend';

interface ProductTileRatingProps {
  shopifyAverageRating?: AverageRatingType;
}

export default function ProductTileRating({
  shopifyAverageRating,
}: ProductTileRatingProps): ReactElement {
  const {myMemberProduct} = useMemberProduct();
  const rating = myMemberProduct?.rating;

  const viableAverageRating = useMemo((): AverageRatingType | null => {
    if (myMemberProduct && myMemberProduct.product.average_rating.value > 0) {
      return myMemberProduct.product.average_rating;
    } else if (shopifyAverageRating && shopifyAverageRating.value > 0) {
      return shopifyAverageRating;
    }
  }, [shopifyAverageRating, myMemberProduct]);

  return (
    <Fragment>
      <div className="product__my-ratings">
        {viableAverageRating && (
          <div className="product__ratings">
            <>
              <i className="icon-heart-empty-2" />
              {viableAverageRating.value} ({viableAverageRating.total}{' '}
              {`rating${viableAverageRating.total !== 1 ? 's' : ''}`})
            </>
          </div>
        )}
        {rating && (
          <div className="you-rated">
            <i className="icon-heart-empty-2" />
            You rated: {rating}
          </div>
        )}
      </div>
    </Fragment>
  );
}
